import React from 'react';
import { Modal } from 'antd';
import { Input, Button } from 'antd';
import { createSqlDatabase, getSqlpadUserDatabases } from '../../../services/ide-apis';

const CreateDbModal = ({ isModalVisible, handleOk, handleCancel}) => {
    const [dbName, setDbName] = React.useState('');
    const [userDatabases, setUserDatabases] = React.useState([]);

    React.useEffect(() => {
        getSqlpadUserDatabases().then((response) => {
            setUserDatabases(response.data);
        })
    }, [])

    function createDb(){
        const reqObj = { databaseName: dbName }
        createSqlDatabase(reqObj).then((response) => {
            handleOk(dbName);
        });
    }

  return (
    
    <Modal
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
        className="cancel-button"
          key="cancel_button"
          onClick={handleCancel}
        >
          Cancel
        </Button>,
        <Button
          style={{color:'#fff',borderColor: "#E96358"}}
          className="create-button"
          key="create_button"
          onClick={createDb}
        >
          Create
        </Button>   
      ]}
      className='custom-modal'
      destroyOnClose={true}
      centered 
    >

      <div className='mt-4'>
        <h4 style={{ marginBottom: '16px', color: '#333', fontSize: '16px', fontWeight: '500' }}>
          Existing Databases
        </h4>
        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {userDatabases.map((database) => (
            <div 
              key={database.id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 16px',
                marginBottom: '8px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                transition: 'all 0.2s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#e9ecef';
                e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ 
                  fontSize: '14px', 
                  fontWeight: '500', 
                  color: '#333',
                  marginBottom: '4px'
                }}>
                  {database.database_name}
                </div>
              </div>
              <Button
                type="primary"
                size="small"
                style={{
                  backgroundColor: '#E96358',
                  borderColor: '#E96358',
                  borderRadius: '6px',
                  fontWeight: '500'
                }}
                onClick={() => {
                  // Handle database selection
                  handleOk(database.database_name);
                }}
              >
                Connect
              </Button>
            </div>
          ))}
        </div>
        {userDatabases.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '20px',
            color: '#666',
            fontSize: '14px'
          }}>
            No databases found. Create a new one below.
          </div>
        )}
      </div>

      <div className="mt-4">
        <h4 style={{ marginBottom: '16px', color: '#333', fontSize: '16px', fontWeight: '500' }}>
          Create New Database
        </h4>
        <Input
            size="large"
            placeholder="Enter database name you want to create"
            onChange={(e) => {
                // Only allow alphanumeric characters and underscores
                const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9_]/g, '');
                setDbName(sanitizedValue);
            }}
            value={dbName}
            className="mb-2"
            maxLength={20}
        />
      </div>

    </Modal>
  );
};

export default CreateDbModal;
